import { addMonths } from 'date-fns';
import { useQuery } from '@tanstack/vue-query';
import { queries } from '@/keys';
import { roleKey } from '@/constants/auth';
import type { User } from '~/types/auth';

const normalizeUser = (data: unknown): User => {
  if (data && typeof data === 'object') return data as User;
  if (typeof data === 'string') return JSON.parse(data) as User;
  return data as User;
};

const useCurrentUser = (enabled?: boolean) => {
  const authStore = useAuthStore();

  return useQuery({
    ...queries.users.me,
    queryFn: async () => {
      if (!authStore.token) return null;
      return $fetch<User>('/api/user/session', {
        headers: { Authorization: `Bearer ${authStore.token}` },
      });
    },
    enabled,
    retry: false,
    select: (data) => {
      if (!data) return null;
      const u = normalizeUser(data);
      const prev = authStore.user;
      authStore.updateUser({ ...(prev ?? {}), ...u } as User);
      if (import.meta.client && u?.role) {
        useStatefulCookie(roleKey, { expires: addMonths(new Date(), 1) }).value = u.role;
      }
      return u;
    },
  });
};

export default useCurrentUser;
